import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)
// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'
import './helpers/helpers.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'
import '@/assets/fontawesome/css/all.css'

// Vue Router
import router from './router'

import VueMoment from 'vue-moment'
Vue.use(VueMoment)

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueTimepicker from 'vue2-timepicker'
Vue.use(VueTimepicker)
// CSS
import 'vue2-timepicker/dist/VueTimepicker.css'

import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
Vue.use(VueGoogleMap, {
  load: {
    apiKey: process.env.VUE_APP_GOOGLE_KEY,
    libraries: ['places', 'visualization', 'geometry']
  }
})

import VueYoutube from 'vue-youtube'

Vue.use(VueYoutube)

import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style (>= Swiper 6.x)
import 'swiper/swiper-bundle.css'

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

import Modal from '@burhanahmeed/vue-modal-2'
Vue.use(Modal)

import VueHtml2pdf from 'vue-html2pdf'
Vue.use(VueHtml2pdf)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
